if (!customElements.get('rt-br-image-menu')) {
  customElements.define('rt-br-image-menu', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('[data-rt-br-menu-details]');
      this.summary = this.details?.querySelector(':scope > summary');
      this.tabs = [...this.querySelectorAll('[data-rt-br-tab]')];
      this.panels = [...this.querySelectorAll('[data-rt-br-panel]')];
      if (!this.details || !this.summary) return;
      this.details.addEventListener('toggle', () => this.summary.setAttribute('aria-expanded', String(this.details.open)));
      this.addEventListener('pointerenter', (event) => { if (event.pointerType !== 'touch') this.open(); });
      this.addEventListener('pointerleave', (event) => { if (event.pointerType !== 'touch') this.closeTimer = window.setTimeout(() => this.close(), 140); });
      this.addEventListener('pointerenter', () => window.clearTimeout(this.closeTimer));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab));
        tab.addEventListener('pointerenter', (event) => { if (event.pointerType !== 'touch') this.activate(tab, false); });
        tab.addEventListener('keydown', (event) => this.onTabKeydown(event, tab));
      });
      this.addEventListener('keydown', (event) => { if (event.key === 'Escape') { this.close(); this.summary.focus(); } });
      document.addEventListener('click', (event) => { if (!this.contains(event.target)) this.close(); });
    }
    open() { this.details.open = true; }
    close() { this.details.open = false; }
    activate(tab, focus = true) {
      const key = tab.dataset.rtBrTab;
      this.tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        item.closest('.rt-br-image-menu__tab-row')?.classList.toggle('is-active', active);
      });
      this.panels.forEach((panel) => { panel.hidden = panel.dataset.rtBrPanel !== key; });
      if (focus) tab.focus();
    }
    onTabKeydown(event, tab) {
      const index = this.tabs.indexOf(tab);
      let next = null;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
      if (event.key === 'Home') next = this.tabs[0];
      if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
      if (next) { event.preventDefault(); this.activate(next); }
    }
  });
}
